const numberFormatter = new Intl.NumberFormat(undefined, {
  maximumFractionDigits: 2,
});

const dateFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'short',
});

export function formatNumber(value: string | number | undefined) {
  if (value === undefined) return undefined;

  return numberFormatter.format(
    typeof value === 'string' ? parseFloat(value) : value
  );
}

export function formatDate(value: string | undefined) {
  return value ? dateFormatter.format(new Date(value)) : undefined;
}
